import { render, staticRenderFns } from "./riskXxdc.vue?vue&type=template&id=15d9540b&scoped=true&"
import script from "./riskXxdc.vue?vue&type=script&lang=js&"
export * from "./riskXxdc.vue?vue&type=script&lang=js&"
import style0 from "./riskXxdc.vue?vue&type=style&index=0&id=15d9540b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9540b",
  null
  
)

export default component.exports